import { BasicProps } from 'antd/lib/layout/layout';
import { cx } from 'common/utils/cx';

interface Props extends BasicProps {
  fullHeight?: boolean;
}

export default function Container({ fullHeight = false, className, ...bag }: Props) {
  return (
    <div
      className={cx('container', className, {
        'container--fullheight': fullHeight,
      })}
      {...bag}
    />
  );
}
